import { Box, Button, Chip } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useLanguage } from '../../../../context/LanguageContext';
import type { useQueryBuilder } from '../../../../hooks/QueryBuilder';
import QueryRuleGroup from './QueryRuleGroup';

const MAX_GROUPS = 2;

interface AdvancedQueryBuilderProps {
    builder: ReturnType<typeof useQueryBuilder>;
}

function AdvancedQueryBuilder({ builder }: AdvancedQueryBuilderProps) {
    const { t } = useLanguage();
    const { groups, categories, fields, addRule, updateRule, removeRule, addGroup, removeGroup } = builder;

    return (
        <>
            {groups.map((group, index) => (
                <Box key={group.id}>
                    <QueryRuleGroup
                        group={group}
                        categories={categories}
                        fields={fields}
                        onAddRule={addRule}
                        onUpdateRule={updateRule}
                        onRemoveRule={removeRule}
                        onRemoveGroup={removeGroup}
                        showCombinator={index > 0}
                        canRemoveGroup={groups.length > 1}
                    />
                    {index < groups.length - 1 && (
                        <Box sx={{ textAlign: 'center', my: 2 }}>
                            <Chip label={t('pages.clients.queryBuilder.or')} sx={{ bgcolor: 'warning.light', color: 'common.white', fontWeight: 600 }} />
                        </Box>
                    )}
                </Box>
            ))}

            {groups.length < MAX_GROUPS && (
                <Button
                    fullWidth
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={addGroup}
                    sx={{ mt: 2, textTransform: 'none', borderColor: 'primary.main', color: 'primary.main', borderStyle: 'dashed' }}
                >
                    {t('pages.clients.queryBuilder.addGroup')}
                </Button>
            )}
        </>
    );
}

export default AdvancedQueryBuilder;
